import React from "react";
import Modal from "src/components/common/Modal";
import AddMedicationFormContent from "./AddMedicationFormContent";

export interface AddMedicationModalProps {
  onSuccess: () => void;
  handleClose: () => void;
  isEdit?: boolean;
  medicationData?: any;
}

const AddMedicationModal: React.FC<AddMedicationModalProps> = (props) => {
  const title = props.isEdit ? "Edit Medication" : "Add New Medication";
  return (
    <Modal
      show={true}
      handleClose={props.handleClose}
      showCloseButton
      title={title}
    >
      <AddMedicationFormContent {...props} />
    </Modal>
  );
};

export default AddMedicationModal;
